import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types'
import * as types from '../../constants/actionTypes';
import { actions as webAssetsActions } from '../../actions/webAssetsActions';
import Drawer from '../Common/Drawer/Drawer';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../Common/Notification';
import ImageChooser from '../Common/ImageChooser/ImageChooser';


export class WebAssetsDrawer extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isFormValid: true,
            isFileRequired: false,
            isLoading: false,
            webAsset: ''
        };

    }

    validateForm = () => {
        let isFileRequired = false;

        if(!this.state.webAsset){
            isFileRequired = true;        
        }

        const isFormValid = !isFileRequired;

        this.setState({
            isFormValid: isFormValid,
            isFileRequired: isFileRequired
        });
        return isFormValid;
    }

    onSave = async () => {
        if(this.validateForm()){
            try {
                this.setState({ isLoading: true });
                const response = await this.props.webAssetsActions.uploadWebAsset(this.state.webAsset, this.props.fileNameToReplace);
                if (response.type === types.UPLOAD_WEB_ASSETS_SUCCESS) {
                    this.props.onSave();
                } else if (response.type === types.UPLOAD_WEB_ASSETS_FAILURE) {
                    Notification("error", "Error", response.payload.message);
                    this.setState({ isLoading: false });
                }
            } catch (error) {
                Notification("error", "Error", error);
                this.setState({ isLoading: false });
            }            
        }
    }

    onFileChange = (file) => {
        this.setState({ webAsset: file });
    }


    render() {
        return (
            <Drawer isWide={false} title="Upload Web Asset"
                onSaveClick={this.onSave}
                onCancelClick={this.props.onCancel}
            >
                <LoadingIndicator isLoading={this.state.isLoading} hideWhileLoading={true}>
                    <form noValidate>
                        <div className="">
                            <ImageChooser name="webAsset" title="Upload Web Asset" onChange={this.onFileChange} />
                        </div>
                    </form>
                </LoadingIndicator>
            </Drawer>
        )
    } 
}

WebAssetsDrawer.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    webAssetsActions: PropTypes.object.isRequired,
    fileNameToReplace: PropTypes.string
}

function mapDispatchToProps(dispatch){
    return {
        webAssetsActions: bindActionCreators(webAssetsActions, dispatch)
    }
}

export default connect(null, mapDispatchToProps)(WebAssetsDrawer);